module.exports = __webpack_public_path__ + "8d395fc2e9d6c5f80a530708f597d46f.svg";